import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const ScreenStyles = styled(OnboardingPage)`
  .page-bg-image-mask {
    background: linear-gradient(
      180deg,
      rgba(20, 17, 30, 0) 43.75%,
      rgba(20, 17, 30, 0.8) 69.09%,
      #14111e 84.92%
    );
  }

  .content-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 16px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
  }

  .local-title {
    margin: 0;
  }
`;
